/* Beton Atelier — minimal theme JS (no dependencies) */
(function () {
  "use strict";

  /* mobile nav */
  var toggle = document.querySelector("[data-nav-toggle]");
  var nav = document.getElementById("SiteNav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* keep the header cart count in sync after AJAX add-to-cart, if used */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener("cart:updated", refreshCartCount);
  window.betonAtelier = { refreshCartCount: refreshCartCount };
})();
